import { keysToSnake } from '@twaice-fe/shared/utilities';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

interface DownloadOptions {
  fileName: string;
  fileType: string;
}

@Injectable()
export class FileDownloadService {
  constructor(private http: HttpClient) {}

  downloadCsv(
    url: string,
    params: Record<string, string>,
    callbacks?: {
      onStart?: () => void;
      onSuccess?: () => void;
      onComplete?: () => void;
      onError?: (err: unknown) => void;
    }
  ): void {
    callbacks?.onStart?.();
    this.http
      .get(url, {
        responseType: 'blob',
        params: keysToSnake(params),
        observe: 'response',
      })
      .pipe(
        catchError((err) => {
          callbacks?.onError?.(err);
          return of(null);
        }),
        finalize(() => callbacks?.onComplete?.())
      )
      .subscribe((response) => {
        if (!response) return;

        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'download.csv';

        const matches = /filename[^;=\n]*=(['"]?)([^'"\n]*)\1/.exec(contentDisposition || '');
        if (matches && matches[2]) {
          filename = matches[2];
        }

        this.triggerClientDownload(response.body as Blob, { fileName: filename, fileType: 'text/csv' });

        callbacks?.onSuccess?.();
      });
  }

  triggerClientDownload(data: string | BufferSource | Blob, { fileName, fileType }: DownloadOptions) {
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);
    // Add Byte Order Mark character at the start of the file so Excel then reads the file as UTF-8
    const bom = '\uFEFF';

    const blob = new Blob([bom, data], { type: fileType });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
